<i18n src="./resources/locales.json"></i18n>

<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon @click="changeFavoriteContactStatus">
        <v-icon :color="contact.isFavoriteContact ? 'orange' : null">mdi-star</v-icon>
      </v-btn>
    </template>
    {{ contact.isFavoriteContact ? $t('removeFavorites') : $t('addFavorites') }}
  </v-tooltip>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SmsFavoriteContact',

  props: {
    contact: {
      type: Object,
      default: null
    }
  },

  methods: {
    ...mapActions('preferences', ['addContactToFavorites', 'removeContactFromFavorites']),
    changeFavoriteContactStatus() {
      if (this.contact.isFavoriteContact) {
        this.removeContactFromFavorites(this.contact);
      }
      else {
        this.addContactToFavorites(this.contact);
      }
    }
  }
};
</script>

<style scoped></style>
